<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" class="mt-1 text-center">
        <h1>Create An Exam</h1>
        <b-button
          variant="outline-success"
          class="float-right"
          
        >Save Question</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mt-1 text-left" style="height:470px; overflow-y:auto;">
        <h2>Add New Question</h2>
        <b-form>
            <b-form-group label="Exam Title *">
            <b-input
              type="text"
             
            ></b-input>
            <b-form-invalid-feedback>This is a required field must enter score</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Course">
            <b-form-select
              
            ></b-form-select>
            <b-form-invalid-feedback
              class="error"
              
            >This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Exam Level *">
            <b-form-radio-group
              id="radio-group-1"
              
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Time Limit *">
            <b-input-group append="Mins" class="mb-1">
              <b-input
                type="number"
                
              ></b-input>
              <b-form-invalid-feedback>This is a required field must enter time limit</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox  value="1">Randomise Questions ?</b-form-checkbox>
            <b-form-checkbox  value="2">Is practice question?</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Total Questions">
            <b-input
              type="number"
             
            ></b-input>
            <b-form-invalid-feedback>This is a required field must enter score</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Number of compulsory questions">
            <b-input
              type="number"
             
            ></b-input>
            <b-form-invalid-feedback>This is a required field must enter score</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Question *" label-for="input-1">
            <b-form-textarea
              placeholder="Enter your question..."
              
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-form-invalid-feedback>This is a required field and must be at least 10 characters.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="score *">
            <b-input
              type="number"
             
            ></b-input>
            <b-form-invalid-feedback>This is a required field must enter score</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Question Level *">
            <b-form-radio-group
              
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          
        </b-form>
      </b-col>
      <!-- Answer Form Starts here -->
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
       
        class="mt-1 text-left"
      >
        <h3>Please select any question type</h3>
      </b-col>

      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
        
        class="mt-1 text-left"
      >
        <h1>Multi Choice</h1>
        <b-form-group>
          <b-form-radio-group
            
            id="radio-group-2"
          >
            <b-form-radio name="some-radios" value="A">Shuffle answers</b-form-radio>
            <b-form-radio name="some-radios" value="B">Show in current order</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Answer *">
          <b-form-textarea
            id="textarea"
            
            placeholder="Enter a possible answer here"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-checkbox  value="true">Is Correct Answer?</b-form-checkbox>

        <b-form-row class="float-right">
          <b-button variant="outline-warning" class="mr-2" >reset</b-button>
          <b-button
            variant="outline-primary"
            class="mr-2"
            
          >Add</b-button>
        </b-form-row>
        <div class="clearfix"></div>

        <br />
        <b-table-simple>
          <thead>
            <tr>
              <th>Answer</th>
              <th>Is Correct</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tr>
            <td></td>
            <td></td>
            <td>
              <font-awesome-icon
                v-b-tooltip.hover
                title="Delete Answer"
                icon="trash"
                
              />
              <font-awesome-icon
                v-b-tooltip.hover
                title="Edit Answer"
                class="ml-2 text-primary"
                icon="edit"
                
              />
            </td>
          </tr>
        </b-table-simple>
      </b-col>
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
       
        class="mt-1 text-left"
      >
        <h1>Fill in the blanks</h1>
        <b-form-group>
          <b-form-radio-group
           
            id="radio-group-2"
          >
            <b-form-radio name="some-radios" value="A">Shuffle answers</b-form-radio>
            <b-form-radio name="some-radios" value="B">Show in current order</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Answer *">
          <b-form-textarea
            id="textarea"
           
            placeholder="Enter a possible answer here"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-checkbox  value="true">Is Correct Answer?</b-form-checkbox>

        <b-form-row class="float-right">
          <b-button variant="outline-warning" class="mr-2" >reset</b-button>
          <b-button
            variant="outline-primary"
            class="mr-2"
            
          >Add</b-button>
        </b-form-row>
        <div class="clearfix"></div>

        <br />
        <b-table-simple>
          <thead>
            <tr>
              <th>Answer</th>
              <th>Is Correct</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tr>
            <td></td>
            <td></td>
            <td>
              <font-awesome-icon
                v-b-tooltip.hover
                title="Delete Answer"
                icon="trash"
                
              />
              <font-awesome-icon
                v-b-tooltip.hover
                title="Edit Answer"
                class="ml-2 text-primary"
                icon="edit"
                
              />
            </td>
          </tr>
        </b-table-simple>
      </b-col>
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
       
        class="mt-1 text-left"
      >
        <h1>Free text</h1>
      </b-col>
    </b-row>
   

  
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
// import { Helper } from "../../helpers";
// import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
// import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "CreateExam",
  mixins: [validationMixin],
  components: {
   
  },
  data() {
    return {
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      showModal: false,
      showEditModal: false,
      
    };
  },
  validations: {
    forms: {
      
    },
    
  },
  computed: {
    ...mapGetters({
      form: "form1"
    })
  },
  mounted() {
    this.$nextTick(function() {
      
    });
  },
  methods: {
    ...mapActions(["setLanguage"]),
    ...mapMutations(["TOGGLE_LOADER"]),
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    
    
    
    
  }
};
</script>

<style>
</style>
